import React from 'react';
import { motion } from 'framer-motion';
import { CtaButton } from './CtaButton';
import { heroImage } from '../../data/presellContent';
export function Hero() {
  return <section id="hero" className="w-full bg-white" data-id="element-30" data-mp="323tn8rtqth5d">
      <div className="max-w-6xl mx-auto px-5 md:px-8 py-14 md:py-20" data-id="element-31" data-mp="324l5z228rke8">
        <div className="grid lg:grid-cols-[1.05fr_1fr] gap-10 lg:gap-14 items-center" data-id="element-32" data-mp="2x4798g63bwvi">
          <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          ease: [0.23, 1, 0.32, 1]
        }} data-id="element-33" data-mp="3b48cg29tvge5">
            <span className="inline-block bg-[#EAF1EE] text-[#3F6B62] px-4 py-1.5 rounded-full text-xs md:text-sm font-semibold tracking-[0.12em]" data-id="element-34" data-mp="3kubaigvt3kjc">
              NEW JOINT DISCOVERY
            </span>

            <h1 className="mt-6 text-[2rem] leading-[1.15] md:text-5xl md:leading-[1.1] font-bold text-[#22322C]" data-id="element-35" data-mp="3tuq0htjptnt6">
              What Many People Call "Wear and Tear" May Actually Be{' '}
              <span className="text-[#3F8C86]" data-id="element-36" data-mp="22s6my4g49xeo">Something Else</span>
            </h1>

            <p className="mt-6 text-lg md:text-xl text-[#4A5D50] leading-relaxed max-w-xl" data-id="element-37" data-mp="22u9pfnyghj0a">
              New findings suggest that joint discomfort may not always be just
              about aging or wear. In many cases, the real issue may also involve
              the loss of the natural lubrication that helps joints move
              smoothly.
            </p>

            <div className="mt-9" data-id="element-38" data-mp="2lq9jd4azuwmi">
              <CtaButton size="large" data-id="element-39" data-mp="2lp85ks2lfw13" />
            </div>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          scale: 0.98
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.5,
          delay: 0.1,
          ease: [0.23, 1, 0.32, 1]
        }} className="relative" data-id="element-40" data-mp="2pqtfq5nqtw7l">
            <img src={heroImage} alt="A woman in her late fifties walking comfortably up stone steps in a sunlit park" className="w-full h-[300px] md:h-[440px] lg:h-[500px] object-cover rounded-2xl" loading="eager" data-id="element-41" data-mp="34i2bkwi8odt6" />
          </motion.div>
        </div>
      </div>
    </section>;
}